import { keywords } from '@/configs/translates.config';

export default {
	'add-new-keyword': `Add new ${keywords.en.singular}`,
	keyword: keywords.en.singular,
	'the-keyword': `the ${keywords.en.singular}?`
}